var map = {
	"./ar.json": 5284,
	"./en.json": 3482,
	"./fr.json": 5627,
	"./ge.json": 8671,
	"./hi.json": 3928,
	"./ja.json": 5548,
	"./ko.json": 7124,
	"./po.json": 6275,
	"./ru.json": 5521,
	"./sp.json": 3256,
	"./zh-CN.json": 3580,
	"./zh-TW.json": 9944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8973;